import { render, staticRenderFns } from "./GeneratedReports.vue?vue&type=template&id=f4fcf0da&scoped=true&"
import script from "./GeneratedReports.vue?vue&type=script&lang=js&"
export * from "./GeneratedReports.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedReports.vue?vue&type=style&index=0&id=f4fcf0da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fcf0da",
  null
  
)

export default component.exports